import { SelectInputProps } from '@/components/select/types';
import React from 'react';
import { useTranslations } from '@/lib/locale-context';

export function Select({
  label,
  name,
  options,
  value,
  onChange,
  placeholder = 'Select an option',
  spacingTop,
  spacingBottom,
  errorMessage,
}: SelectInputProps) {
  const { t } = useTranslations();

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChange?.(event.target.value);
  };

  return (
    <div
      className={`${
        spacingTop && spacingBottom
          ? 'py-4 md:py-8 lg:py-20'
          : spacingTop
            ? 'pt-4 md:pt-8 lg:pt-20'
            : spacingBottom
              ? 'pb-4 md:pb-8 lg:pb-20'
              : ''
      } w-full`}
    >
      <label
        htmlFor={`select-${name}`}
        className="mb-2 block text-sm font-medium text-brand-700"
      >
        {label}
      </label>
      <select
        id={`select-${name}`} // Dynamically use the name for the id
        name={name} // Ensure the select element has the correct name
        value={value ?? ''}
        onChange={handleChange}
        className="focus:ring-blue-500 w-full rounded border px-4 py-2 text-neutral-600 focus:outline-none focus:ring-2"
      >
        <option value="" disabled>
          {placeholder || t('ui.selectPlaceholder')}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {errorMessage && (
        <p className="mt-2 text-sm text-red-100" role="alert">
          {errorMessage}
        </p>
      )}
    </div>
  );
}
